import React from 'react';
import { Formik, Field, Form } from 'formik';
import pick from 'lodash/pick';
import * as FIELD_TYPES from '../../constants/forms.constants';
import FieldText from './FieldText';
import Input from './Input';
import Bool from './Boolean';
import ViewLayout from './ViewLayout';
import Colour from './Colour';
import WeekPickerForForm from './WeekPickerForForm';
import ScenarioPickerForForm from './ScenarioPickerForForm';

const FIELD_COMPONENTS = {
  [FIELD_TYPES.FIELD_TEXT]: FieldText,
  [FIELD_TYPES.INPUT]: Input,
  [FIELD_TYPES.BOOLEAN]: Bool,
  [FIELD_TYPES.VIEW_LAYOUT]: ViewLayout,
  [FIELD_TYPES.COLOUR]: Colour,
  [FIELD_TYPES.WEEK_PICKER]: WeekPickerForForm,
  [FIELD_TYPES.SCENARIO_PICKER]: ScenarioPickerForForm,
};

const FormRenderer = ({
  scaffold,
  sideEffectHandler,
  initialValues,
  actions,
  onSubmit,
  onBlur,
  lookupData,
  isSubmitting,
  enableReinitialize,
}) => (
  <div>
    <Formik
      initialValues={initialValues || scaffold.initialValues}
      validationSchema={scaffold.schema}
      onSubmit={onSubmit}
      onBlur={onBlur}
      validateOnChange={false}
      validateOnBlur
      isSubmitting={isSubmitting}
      enableReinitialize={enableReinitialize}
      render={formik => (
        <Form>
          {scaffold.definition.map(field => (
            <Field
              component={FIELD_COMPONENTS[field.component]}
              lookupData={pick(lookupData, field.lookupData)}
              fieldDefinition={field}
              sideEffectHandler={sideEffectHandler}
              key={field.key}
              name={field.key}
            />
          ))}
          {actions && actions(formik)}
        </Form>
      )}
    />
  </div>
);

export default FormRenderer;
